import { initialState, initialStateByModule } from './state'
import { getUserData } from '@/api/services'

const IS_LOADING_USER_DATA = 'isLoadingUserData'
const RESET_PERSONAL_DATA = 'resetPersonalData'
const SET_PERSONAL_DATA = 'setPersonalData'
const GET_PERSONAL_DATA_ESTATE_OWNER = 'getPersonalDataEstateOwner'
const CHANGE_PERSONAL_DATA_NAME = 'changePersonalDataName'
const CHANGE_PERSONAL_DATA_BIRTHDAY = 'changePersonalDataBirthday'
const CHANGE_PERSONAL_DATA_CPF = 'changePersonalDataCpf'
const CHANGE_PERSONAL_DATA_CELLPHONE = 'changePersonalDataCellphone'
const CHANGE_PERSONAL_DATA_EMAIL = 'changePersonalDataEmail'
const CHANGE_PERSONAL_DATA_CHECK_EMAIL = 'changePersonalDataCheckEmail'
const CHANGE_PERSONAL_DATA_ESTATE_OWNER = 'changePersonalDataEstateOwner'
const CHANGE_PERSONAL_DATA_GENDER = 'changePersonalDataGender'

const state = initialStateByModule('personalData')

const getters = {
  [GET_PERSONAL_DATA_ESTATE_OWNER]: state => state.estateOwner
}

const mutations = {
  [IS_LOADING_USER_DATA] (state, payload) {
    state.isLoadingUserData = payload
  },
  [RESET_PERSONAL_DATA] (state) {
    const initState = initialState.personalData
    Object.keys(initState).forEach(key => {
      state[key] = initState[key]
    })
  },
  [SET_PERSONAL_DATA] (state, payload) {
    Object.assign(state, payload)
  },
  [CHANGE_PERSONAL_DATA_NAME] (state, payload) {
    state.name = payload
  },
  [CHANGE_PERSONAL_DATA_BIRTHDAY] (state, payload) {
    state.birthday = payload
  },
  [CHANGE_PERSONAL_DATA_CPF] (state, payload) {
    state.cpf = payload
  },
  [CHANGE_PERSONAL_DATA_CELLPHONE] (state, payload) {
    state.cellphone = payload
  },
  [CHANGE_PERSONAL_DATA_EMAIL] (state, payload) {
    state.email = payload
  },
  [CHANGE_PERSONAL_DATA_CHECK_EMAIL] (state, payload) {
    state.checkEmail = payload
  },
  [CHANGE_PERSONAL_DATA_ESTATE_OWNER] (state, payload) {
    state.estateOwner = payload
  },
  [CHANGE_PERSONAL_DATA_GENDER] (state, payload) {
    state.gender = payload
  }
}

const actions = {
  getUserData ({ commit, rootState }, { cpf, isEmployee = false }) {
    commit(IS_LOADING_USER_DATA, true)
    return getUserData(cpf, isEmployee)
      .then((response) => {
        commit(IS_LOADING_USER_DATA, false)

        const { data, status } = response

        if (status !== 200) return

        commit(SET_PERSONAL_DATA, {
          name: data.name,
          birthday: data.birthDate && data.birthDate.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$3$2$1'),
          cellphone: data.phone,
          email: data.email,
          checkEmail: data.email,
          gender: data.gender !== 'U' ? data.gender : '',
          ...(data.isEmployee && {
            isEmployee: data.isEmployee
          })
        })

        if (data.address) {
          commit('address/setAddress', {
            zipcode: data.address.zipCode,
            city: data.address.city,
            complement: data.address.additionalAddressInformation,
            neighborhood: data.address.neighborhood,
            state: data.address.state,
            streetName: data.address.publicPlace,
            streetNumber: data.address.numberAddress
          }, { root: true })

          rootState.steps.address = 'finished'
        }

        if (data.nextRecurrencyDate) {
          commit('payment/setNextRecurrencyDate', data.nextRecurrencyDate, { root: true })
        }

        return response
      })
      .catch(error => {
        commit(IS_LOADING_USER_DATA, false)

        this._vm.$sentry.logWithContext({
          level: 'error',
          tags: {
            app_product: rootState.product.alias,
            app_step: rootState.steps.currentStep,
            app_errorZone: 'getUserData'
          },
          ctx: {
            label: '[PERSONAL DATA] - getUserData'
          },
          error
        })

        return error.response
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
